import { useCallback } from "react"
import { Box, Typography, FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material"
import { SETUP_GOALS, SetupGoal } from "connected-components/optimize-experiments/constants"
import { SetupSection } from "connected-components/optimize-experiments/configuration-sections"

import "./style.scss"

interface SetupProps {
  setup: SetupSection
  onSetupChange: (setup: SetupSection) => void
}

export default function Setup({ setup, onSetupChange }: SetupProps) {
  const handleFieldChange = useCallback(<K extends keyof SetupSection>(field: K, value: SetupSection[K]) => {
    const newSetup: SetupSection = {
      ...setup,
      [field]: value,
    }
    onSetupChange(newSetup)
  }, [setup, onSetupChange])

  return (
    <Box className="components_setup">
      <Typography color="inherit" noWrap className="setup-label">
        Setup
      </Typography>

      <Box className="setup-content">
        <Box className="setup-goal">
          <Typography color="inherit" noWrap className="setup-goal-label">
            Goal:
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup
              value={setup.goal}
              onChange={(event) => handleFieldChange("goal", event.target.value as SetupGoal)}
              className="setup-goal-radio-group"
            >
              <FormControlLabel
                value={SETUP_GOALS.MINIMIZE_TOTAL_RISK}
                control={<Radio size="small" />}
                label="Minimize total risk"
                className="setup-goal-radio-option"
              />
            </RadioGroup>
          </FormControl>
        </Box>
      </Box>
    </Box>
  )
}
